import * as admin from './admin';
import * as user from './user';
import * as auth from './auth';
import * as oauth2 from './oauth2';
import * as partner from './partner';

const m8API = { admin, user, auth, oauth2, partner };

export { m8API };
